import { VOICE_BACKEND_URL } from "./serverData"

export const getChatResponse = async (message, inputLanguage, outputLanguage) => {
    inputLanguage = inputLanguage || "en"
    outputLanguage = outputLanguage || "en"
    const response = await fetch(`${VOICE_BACKEND_URL}/translate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...message, inputLanguage, outputLanguage }),
    });
    const data = await response.json();
    return data;
}

export const getVoiceResponse = async (content, inputLanguage, outputLanguage) => {
    let userLocale = navigator.language || navigator.userLanguage;
    userLocale = "en";
    inputLanguage = inputLanguage || "en"
    outputLanguage = outputLanguage || "en"
    const response = await fetch(`${VOICE_BACKEND_URL}/translate`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ content, input_type: "audio", output_type: "audio", inputLanguage: inputLanguage, outputLanguage: outputLanguage }),
    });
    const data = await response.json();
    return data;
}